import type { IProModalCustomStyles } from "pro-features/components/Modals/src/ProModal";

export const ADD_ICON = "add";
export const DELETE_ICON = "delete";
export const NO_DATA = -2;

export const proModalStyles: IProModalCustomStyles = {
    content: {
        boxSizing: "border-box",
        width: "480px",
        padding: 0,
    },
};
